export interface DelimiterConfig {
  aliases: string[];
  isFirst: boolean;
}

export const aliasesForDelimiters: Record<string, DelimiterConfig> = {
  "is for any": {
    aliases: ["is for any"],
    isFirst: true,
  },
  is: {
    aliases: ["is"],
    isFirst: true,
  },
  "=": {
    aliases: ["="],
    isFirst: true,
  },
  and: {
    aliases: [
      "and",
      "and a",
      "and any",
      "and for",
      "and it will",
      "and it's",
      "and it's a",
      "for",
      "for a",
      "for any",
      "when",
      "when a",
      "when any",
      "when it will",
      "when it's",
      "when it's a",
      "when it's any",
      "when it's for",
    ],
    isFirst: false,
  },
  "and not": {
    aliases: [
      "and not",
      "not a",
      "not for",
      "not for a",
      "not for any",
      "and not for",
      "and it's not",
      "and it's not a",
      "and it's not for",
      "when it's not",
      "when it's not a",
      "when it's not for",
    ],
    isFirst: false,
  },
  or: {
    aliases: ["or", "or a", "or any", "or for", "or it will", "or it's", "or it's a"],
    isFirst: false,
  },
  "or not": {
    aliases: ["or not", "or not a", "or not for", "or it's not a", "or it's not for"],
    isFirst: false,
  },
};
